import _extends from "@babel/runtime/helpers/extends";
import { Field } from '@atlaskit/form';
import TextField from '@atlaskit/textfield';
import React from 'react';

const EmailField = props => {
  return /*#__PURE__*/React.createElement(Field, {
    name: "username",
    label: "Email address",
    isRequired: props.isRequired,
    defaultValue: props.defaultValue,
    isDisabled: props.isDisabled
  }, ({
    fieldProps
  }) => /*#__PURE__*/React.createElement(TextField, _extends({
    type: "email"
  }, fieldProps, {
    width: props.width
  })));
};

export default EmailField;